import {
    SEO_RESULTS_PER_PAGE,
    LandingPagesOccupationBeats,
    LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
    SEO_URL_LANDING_PAGE_PREFIX
} from "@authory-packages/seo-static-data";
import { ExamplesPageLayout } from "../../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>Explore portfolio use cases by professional category</>}
        description={
            <>
                Learn how Authory helps creators from all professional categories, from journalism to content marketing to research. Find the
                portfolio setup that fits your needs.
            </>
        }
        panelLinks={LandingPagesOccupationBeats.slice(0, 100).map((occ) => ({
            url: `${APPLICATION_ROUTES.USE_CASES}/${SEO_URL_LANDING_PAGE_PREFIX}${occ.key}`,
            label: occ.occupation
        }))}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"Portfolio Use Cases by Professional Category | Authory"}
        ogDescription={
            "Browse Authory portfolio solutions by professional category, e.g. journalism, marketing, research, and more. See how we help creators across industries shine."
        }
        embedConf={[]}
        pagination={{
            page: 1,
            limit: SEO_RESULTS_PER_PAGE,
            pages: LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
            total: LandingPagesOccupationBeats.length,
            prev: null,
            next: 2 < LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES ? 2 : null
        }}
        paginationURL={APPLICATION_ROUTES.USE_CASES_PROFESSION_CATEGORIES}
        faq={[]}
    />
);

export default ExampleJobPage;
